<template>
  <div class="transition">
    <v-card class="p-2" style="min-height: 130px;" shaped elevation="10">
      <h2 class="text-md md:text-base text-neutral-600">   Alterações </h2>


      <span
        class="text-sm absolute whitespace-no-wrap text-neutral-500 bg-white bottom-0 m-3 left-0"
        style=""
      >
        {{ moment().locale("pt-br").format("MMM [de] YYYY") }}
      </span>
      <div>
      </div>

      <v-row class="mt-1">
        <v-col md="6" cols="12">
          <div class="text-center">
            <div class="font-light text-neutral-600">Semana</div>
            <div class="font-bold text-primary-600 text-lg">
              {{ dataSet.in_week ? dataSet.in_week : "--" }}
            </div>
          </div>
        </v-col>
        <v-col md="6" cols="12">
          <div class="text-center">
            <div class="font-light text-neutral-600">Mês</div>
            <div class="font-bold text-primary-600 text-lg">
              {{ dataSet.in_month ? dataSet.in_month : "--" }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { quantityAlteracaoRequest } from "@/services/requests/charts";
import moment from "moment";

export default {
  name: "CnpjCountStats",
  data() {
    return {
      dataSet: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    onboarding_search() {
      return this.$store.state.configEmpresa.onboarding_search;
    },
  },
  watch: {
    onboarding_search() {
      this.fetchData();
    },
  },
  methods: {
    moment,
    fetchData() {
      quantityAlteracaoRequest().then(
        (response) => (this.dataSet = response.data)
      );
    },
  },
};
</script>

<style scoped>
</style>
